import * as React from "react";

const Twitter: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="m13.903 10.47 7.445-8.464h-1.763l-6.468 7.35-5.163-7.35H2L9.809 13.12 2 21.995h1.763l6.828-7.761 5.455 7.761H22L13.903 10.47zm-2.416 2.747-.791-1.106-6.294-8.808h2.707l5.082 7.11.791 1.104 6.603 9.238h-2.711l-5.387-7.538z"
            />
        </svg>
    );
};

export default React.memo(Twitter);
